__turbopack_context__.v({
  "className": "inter_1b545fac-module__b8QJrq__className",
  "variable": "inter_1b545fac-module__b8QJrq__variable",
});
